module.exports = __webpack_public_path__ + "static/media/headshot.2f8a1bee.png";